import React from 'react';
import { Tabs } from '../components';
import { GlossaryList } from './GlossaryList';
import { AttributeList } from './AttributeList';
import { useQueryParams } from '../hooks';
import { Asset } from '../helpers';

/**
 * The Glossaries page: a shell around the two lists it can show.
 *
 * A glossary holds entities and attributes, but an attribute is also useful to browse on its own —
 * across every glossary, regardless of which one it sits in. Rather than making that a second top-level
 * destination, it is the page's other tab. Each tab renders a self-contained component that owns its
 * own data and dialogs, so this file stays a shell and neither list has to know about the other.
 */
export const Glossaries = () => {
  const { queryParams, setHistory } = useQueryParams();

  /**
   * These are the page's top-level tabs, so they write the `tab` query param. `object` is reserved for
   * tabs nested inside one of them, which keeps the two levels distinguishable in the URL.
   */
  const onTabChange = tab => {
    setHistory({ tab: tab });
  };

  return (
    <div className="Glossaries wide-margin">
      <Tabs
        className="left"
        onTabChange={onTabChange}
        showResultCount={false}
        defaultSelectedTab={{ tab: queryParams.tab || Asset.Glossary }}
      >
        <div label="Glossaries" tabid={Asset.Glossary}>
          <GlossaryList />
        </div>
        <div label="All Attributes" tabid={Asset.Attribute}>
          <AttributeList />
        </div>
      </Tabs>
    </div>
  );
};
